import React from "react";

export default function CustomFacet({ handleFilterClick, productCustom }) {
  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }
  productCustom = sortObject(productCustom);
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("custom") &&
    plpFacetLabel.custom != ""
      ? plpFacetLabel.custom
      : "Custom";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productCustom).map((custom, i) => {
          if (custom && productCustom[custom] > 0) {
            return (
              <div>
                <span
                  id={`custom-filter-${i}`}
                  key={i}
                  data-value={`${custom.toLowerCase().replace(/,/g, "+")}`}
                  onClick={(e) =>
                    handleFilterClick("custom", e.target.dataset.value)
                  }>
                  {" "}
                  {custom.replace(/,/g, "+")} {` (${productCustom[custom]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
